import Grid from '@material-ui/core/Grid';
import Clock from './Clock';
import { approximateMoonPhase } from '../utils/moonPhase';
import { convertMJD } from '../utils/timeUtils';
import logo from '../assets/atlas_logo.svg';
import './Header.css';

function Header() {
  const MJD = convertMJD(new Date());

  return (
    <div className="header">
    <Grid container alignItems="center">
      <Grid item xs={4} sm={2} md={1}>
        <img src={logo} alt='ATLAS logo' style={{ width: '100%' }} />
      </Grid>
      <Grid item xs={8} sm={10} md={11} >
        <h1>ATLAS Summit Status</h1>
        <div className='row'>
          <Clock timezone='UTC' />
          <Clock timezone='MJD' />
          <div>{approximateMoonPhase(MJD)}</div>
        </div>
      </Grid>
    </Grid>
    </div>
  );
}
export default Header;
